import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import CtaSections from "~/blocks/CtaSections";

const CtaSectionsBlock = ({
    ctaSections: { backgroundColor, vertical, sections },
}) => <CtaSections {...{ backgroundColor, vertical, sections }} />;

CtaSectionsBlock.propTypes = {
    ctaSections: PropTypes.shape({
        sections: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                links: PropTypes.arrayOf(PropTypes.shape({})),
            }).isRequired,
        ),
        backgroundColor: PropTypes.string,
        vertical: PropTypes.bool,
    }),
};

export default CtaSectionsBlock;

export const FRAGMENT = graphql`
    fragment CtaSectionsBlockFragment on WpAcfCtaSectionsBlock {
        name
        ctaSections {
            sections {
                title
                links {
                    linkLabel
                    linkUrl
                    icon
                    type
                    formId
                    doc {
                        ...DocumentFragment
                    }
                }
            }
            backgroundColor
            vertical
        }
    }
`;
